export default __webpack_public_path__ + "static/meta-img-372266eb936e509c87400c67ec26b517.jpg";